import { LoginForm } from '@/Core/Components/Auth'
import { useNotification } from '@/Core/Hooks/useNotification'
import { AppConfig } from '@/Ship/Configs/AppConfig'
import { normalizePhone } from '@/Ship/Helpers/normalizePhone'

/** Підпис поля логіна (`SPEC-005` §7.4, ADR 023). */
export const LOGIN_PHONE_LABEL = 'Мобільний телефон'

/**
 * Телефон приводиться до вигляду з бази ДО відправки: бек шукає точний збіг
 * (`SPEC-005` §3.3, Р-2), тож «+38 (099) 123-45-06» інакше не знайшовся б.
 */
const toStoredPhone = (data: Record<string, unknown>): Record<string, unknown> => ({
    ...data,
    phone: normalizePhone(String(data['phone'] ?? '')),
})

/**
 * Форма входу за телефоном.
 *
 * Одна на обидва шляхи, якими користувач бачить вхід: сторінку `/public/login`
 * і `templateError403` на будь-якій внутрішній адресі (`LoginPageTemplate`).
 * Інакше нормалізацію телефону легко налаштувати лише в одному з них — і
 * другий шлях мовчки не пускав би людину з номером «у людському записі».
 *
 * Помилку сервера ядрова форма показує рядком під полями, а `onError` додає
 * тост, як у легасі. PD передавав неіснуючий проп `showError`, і тосту не було.
 *
 * Куди після входу: без `onSuccess` ядрова форма веде на `/`. Так і має бути
 * на `/public/login`, але на внутрішній адресі людина відкривала конкретну
 * сторінку (посилання з листа, закладка) — `LoginPageTemplate` передає
 * `stayOnPage`, і після входу оболонка просто відмальовує цю сторінку.
 */
export const PhoneLoginForm = ({ stayOnPage = false }: { stayOnPage?: boolean }) => {
    const { showError } = useNotification()

    return (
        <LoginForm
            loginFieldName="phone"
            loginFieldLabel={LOGIN_PHONE_LABEL}
            forgotPasswordPageUrl={AppConfig.forgotPasswordPageUrl}
            transformLoginData={toStoredPhone}
            onError={(title, message) => showError(title, message)}
            {...(stayOnPage ? { onSuccess: () => {} } : {})}
        />
    )
}
